/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedPxtraInvoiceList } from '../models/PaginatedPxtraInvoiceList';
import type { PxtraInvoice } from '../models/PxtraInvoice';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PaymentService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Permission Viewset mixin to override the default
     * behavior from AutoPermissionViewSetMixin.
     * @returns PaginatedPxtraInvoiceList
     * @throws ApiError
     */
    public paymentInvoicesList({
        company,
        limit,
        offset,
    }: {
        company: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedPxtraInvoiceList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payment/invoices/',
            query: {
                'company': company,
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * Permission Viewset mixin to override the default
     * behavior from AutoPermissionViewSetMixin.
     * @returns PxtraInvoice
     * @throws ApiError
     */
    public paymentInvoicesRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this pxtra invoice.
         */
        id: string,
    }): CancelablePromise<PxtraInvoice> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payment/invoices/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Get a short living link to the stripe billing portal
     * @returns string
     * @throws ApiError
     */
    public paymentInvoicesBillingLinkRetrieve({
        company,
    }: {
        company: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payment/invoices/billing_link/',
            query: {
                'company': company,
            },
        });
    }

}
